import * as React from 'react';
const SvgAddDocument = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.208 3.542a2 2 0 0 1 2-2h5.417a.75.75 0 0 1 .53.22l5.417 5.416c.14.14.22.332.22.53v8.75a2 2 0 0 1-2 2H5.207a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v12.916a.5.5 0 0 0 .5.5h9.583a.5.5 0 0 0 .5-.5v-8h-3.416a2 2 0 0 1-2-2V3.042zm6.167 1.06 2.856 2.856h-2.356a.5.5 0 0 1-.5-.5zM10 9.875a.75.75 0 0 1 .75.75v1.333h1.333a.75.75 0 0 1 0 1.5H10.75v1.334a.75.75 0 1 1-1.5 0v-1.334H7.916a.75.75 0 0 1 0-1.5H9.25v-1.333a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAddDocument;
